import { makeStyles } from "@material-ui/core/styles";

export const useTerminalUsersStyles = makeStyles((theme) => ({
    terminalUserListTitle: {
        fontWeight: "bold",
        fontSize: "1.7em",
      },
      SearchInput: {
        marginLeft: theme.spacing(1),
        flex: 1,
      },
      searchPaper: {
        padding: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
      },
      textFieldStyle:{
        "& label span": {
          color: "red"
        }
      },
     
      table: {
        minWidth: 450,
      },
}))